import "./TitleLogo.css"
import AutomaticMENLogo from "../../assets/AUTOMATIC MEN LOGO.png"
export default function TitleLogo() {
    return(
        <div className="header-title_logo_container">
                <img src={AutomaticMENLogo} className="header-logo" alt=""/>
                <h5 className="header-title">Automatic MEN</h5>
            </div>
    );
}